<template>
  <div>
    <vx-card class="w-full">
      <div class="flex justify-between items-center">
        <h4>옹벽 엑셀(FMS) 업로드</h4>
        <vs-button color="secondary" @click="onClickSave">등록</vs-button>
      </div>

      <!-- 기본정보 -->
      <FieldSelectModule
        title="작성자 정보"
        v-model="form.stdInfo"
        :typeslabel="{
          date: '등록일',
        }"
        :board="board"
        :types="['department', 'com_name', 'rank', 'writer_name', 'date']"
        class="mt-28px"
      />

      <!-- 파일 업로드 -->
      <div class="mt-28px">
        <div class="writeGridContainer">
          <div class="writeGridLineItem">
            <div>파일 업로드</div>
            <div>
              <vs-button color="secondary" type="border" :href="excelLink">엑셀 템플릿 다운로드</vs-button>
              <vs-button color="secondary" class="ml-2" @click="onClickExcelUpload"> 작성 엑셀 업로드 </vs-button>
              <input v-show="false" ref="excelInput" type="file" multiple @change="readFile" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-between items-center mt-6 mb-4">
        <h5><i class="dot"></i> 등록 대상 시설물 정보</h5>
      </div>

      <div>
        <table class="excel-table">
          <colgroup>
            <col width="50" />
            <col width="60" />
            <col width="400" />
            <col v-for="_ in 7" :key="`col_${_}`" />
            <col width="120" />
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>No.</th>
              <th>관리 부서 및 업체 지정</th>
              <th>시설물번호</th>
              <th>관리번호</th>
              <th>시설물명</th>
              <th>관리주체</th>
              <th>소유자</th>
              <th>전화번호</th>
              <th>보관자</th>
              <th>수정/삭제</th>
            </tr>
          </thead>
          <tbody v-for="(excel, excel_i) in excelData" :key="`${excel_i}_${excel[0]}`">
            <tr>
              <td>
                <img src="@/assets/icons/triangle_down.svg" class="mx-auto duration-200 cursor-pointer" :style="{ transform: excel.open ? 'rotate(0deg)' : 'rotate(-90deg)' }" @click="excel.open = !excel.open" />
              </td>
              <td>{{ excel_i + 1 }}</td>
              <td v-for="(col, col_key) in excel.row" :key="`${excel_i}_td_${col_key}`">
                <div v-if="editExcelIndex === excel_i" class="p-1">
                  <CompanySelector v-if="col_key === '관리부서및업체지정'" multiple class="w-full" v-model="excel.row[col_key]" />
                  <ml-input v-else-if="col_key === '시설물번호'" v-model="excel.form.facilityNumber" class="w-full" />
                  <ml-input v-else-if="col_key === '관리번호'" v-model="excel.form.managementNumber" class="w-full" />
                  <ml-input v-else-if="col_key === '시설물명'" v-model="excel.form.facilityName" class="w-full" />
                  <ml-input v-else-if="col_key === '관리주체'" v-model="editExcelData.form.management_entry" class="w-full" />
                  <ml-input v-else-if="col_key === '소유자'" v-model="excel.form.owner" class="w-full" />
                  <ml-input v-else-if="col_key === '전화번호'" v-model="excel.form.phoneNumber" class="w-full" />
                  <ml-input v-else-if="col_key === '보관자'" v-model="excel.form.curstodian" class="w-full" />
                  <ml-input v-else v-model="editExcelData.row[col_key]" class="w-full" />
                </div>
                <div v-else>
                  <div class="flex items-center justify-center gap-2">
                    <CompanySelector v-if="col_key === '관리부서및업체지정'" multiple class="w-full" v-model="excel.row[col_key]" :show-empty-message="true" />
                    <p v-else-if="col_key === '시설물번호'">{{ excel.form.facilityNumber || "-" }}</p>
                    <p v-else-if="col_key === '관리번호'">{{ excel.form.managementNumber || "-" }}</p>
                    <p v-else-if="col_key === '시설물명'">{{ excel.form.facilityName || "-" }}</p>
                    <p v-else-if="col_key === '관리주체'">{{ excel.form.management_entity || "-" }}</p>
                    <p v-else-if="col_key === '소유자'">{{ excel.form.owner || "-" }}</p>
                    <p v-else-if="col_key === '전화번호'">{{ excel.form.phoneNumber || "-" }}</p>
                    <p v-else-if="col_key === '보관자'">{{ excel.form.custodian || "-" }}</p>
                    <p v-else>{{ col || "-" }}</p>
                  </div>
                  <p v-if="excel.err && excel.err[col_key]" class="errMsg">{{ excel.err[_num_i] }}</p>
                </div>
              </td>
              <td>
                <div class="flex justify-center gap-3">
                  <fragment v-if="editExcelIndex === excel_i">
                    <button @click="onClickFinishExcelData(excel_i)">
                      <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                    </button>
                    <button @click="onClickCancelExcelData(excel_i)">
                      <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                    </button>
                  </fragment>
                  <fragment v-else>
                    <button v-if="false" @click="onClickEditExcelData(excel_i)">
                      <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                    </button>
                    <button @click="onClickRemoveExcelData(excel_i)">
                      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                    </button>
                  </fragment>
                </div>
              </td>
            </tr>
            <tr v-show="excel.open">
              <td colspan="11" class="p-0">
                <RetainingWallWriteBody :form="excel.form" :init-cat1-list="cat1List" :category-info="excel.categoryInfo" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";

import XLSX from "xlsx";
import moment from "moment";
import config from "/public/config";
import RetainingWallWriteBody from "@/views/fields/single-page/retaining-wall/RetainingWallWriteBody.vue";
import { levenshteinDistance } from "@/util/DataUtil";

export default {
  components: {
    RetainingWallWriteBody,
    FieldSelectModule,
    CompanySelector,
  },
  data() {
    return {
      board: {
        projectTitle: this.$store.state.project.projectInfo.field_name,
        writer: {}, //작성자 정보
        readonly: false, // 읽기전용인가
        isPrint: false,
        viewSaveBtn: true,
        viewRemoveBtn: true,
      },
      form: {
        stdInfo: {},
      },

      excelData: [],

      editExcelIndex: null,
      editExcelData: null,

      cat1List: [],
      facilityCategoryList: [],
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    boardId() {
      return Number(this.$route.name.slice(-3));
    },
    myInfo() {
      return this.$store.state.member.memberInfo;
    },
    excelLink() {
      return `${config.BASE_API_URL}/storage/app/media/%EC%8B%9C%EC%84%A4%EB%AC%BC%EA%B4%80%EB%A6%AC%EB%8C%80%EC%9E%A5_%EC%98%B9%EB%B2%BD.xls`;
    },
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      await this.$store.dispatch("USER_INFO");
      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        department: this.$store.state.auth.userInfo.department,
        section: this.$store.state.auth.userInfo.section,
        rank: this.$store.state.auth.userInfo.rank,
        com_name: "",
      };

      await this.$store.dispatch("company/LOAD_COMPANY", {
        companyId: this.board.writer.company_id,
      });
      this.board.writer.com_name = this.$store.state.company.companyInfo.com_name;
      if (!this.board.writer.section) {
        this.board.writer.section = this.board.writer.com_name;
      }

      // 시설물 구분 값을 불러온다
      const response = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
      if (response.data) {
        this.facilityCategoryList = response.data;
        const _cat1List = this.facilityCategoryList.map((item) => item.cat1);
        const uniqueCat1List = [...new Set(_cat1List)];
        this.cat1List = this.setCatOther(uniqueCat1List);
      }
    },

    /**
     * 주어진 cat1과 cat3에 가장 가까운 시설 카테고리를 찾는 함수입니다.
     * 이 함수는 레벤슈타인 거리(Levenshtein Distance)를 사용하여 cat3와 각 시설 카테고리 간의 '편집 거리'를 계산하고,
     * 가장 작은 편집 거리를 가진 시설 카테고리를 반환합니다.
     *
     * @param {string} cat1 - 시설 카테고리의 첫 번째 분류
     * @param {string} cat3 - 시설 카테고리의 세 번째 분류
     * @returns {Object} cat3와 가장 가까운 시설 카테고리
     */
    findFacilityCategory(cat1, cat3) {
      const cat1Items = this.facilityCategoryList.filter((item) => item.cat1 === cat1);

      return cat1Items.reduce((prev, curr) => {
        const prevDistance = levenshteinDistance(cat3, prev.cat3);
        const currDistance = levenshteinDistance(cat3, curr.cat3);
        return prevDistance < currDistance ? prev : curr;
      });
    },

    onClickExcelUpload() {
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },
    // 엑셀데이터 파싱
    async readFile(event) {
      // get File object from input tag
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        // declare FileReader, temp result
        const reader = new FileReader();
        const tmpResult = {};

        // if you use "this", don't use "function(e) {...}"
        reader.onload = async (e) => {
          let data = e.target.result;
          data = new Uint8Array(data);
          // get excel file
          const excelFile = XLSX.read(data, { type: "array", cellDates: true });

          // get prased object
          excelFile.SheetNames.forEach(function (sheetName) {
            const exs = excelFile.Sheets[sheetName];
            const _temp = {};
            for (const key in exs) {
              if (key.includes("!") || !exs[key].v) continue;
              _temp[key] = exs[key].v;
            }
            tmpResult[sheetName] = _temp;
          });
          const parseExcel = tmpResult.sheet1;

          let 관리주체구분 = "";
          if (parseExcel.AM23) {
            관리주체구분 = "민간";
          } else if (parseExcel.Z25) {
            관리주체구분 = "중앙부처";
          } else if (parseExcel.AD25) {
            관리주체구분 = "지자체";
          } else if (parseExcel.AI25) {
            관리주체구분 = "(국가/지방)공기업";
          }

          let 소유자구분 = "";
          if (parseExcel.BG23) {
            소유자구분 = "민간";
          } else if (parseExcel.AU25) {
            소유자구분 = "중앙부처";
          } else if (parseExcel.BB25) {
            소유자구분 = "지자체";
          } else if (parseExcel.BE25) {
            소유자구분 = "(국가/지방)공기업";
          }

          const addresses = [];
          if (parseExcel.B22) addresses.push(parseExcel.B22);
          if (parseExcel.D22) addresses.push(parseExcel.D22);
          if (parseExcel.H22) addresses.push(parseExcel.H22);
          if (parseExcel.N22) addresses.push(parseExcel.N22);
          if (parseExcel.N24) addresses.push(parseExcel.N24);

          const 전화번호 = this.getCellData(parseExcel, "AK14").replace(/ /g, "").replace("전화번호:", "");

          const 구간정보 = [];
          for (let i = 63; i < 76; i++) {
            구간정보.push({
              시점: this.getCellData(parseExcel, `B${i}`),
              종점: this.getCellData(parseExcel, `W${i}`),
              표준패턴: this.getCellData(parseExcel, `AS${i}`),
            });
          }

          const cat1 = this.getCellData(parseExcel, "AX20");
          const cat3 = this.getCellData(parseExcel, "AM20");
          const facilityCategory = this.findFacilityCategory(cat1, cat3);


          // 옹벽 상세제원의 경우, 옹벽 단수에 따라서 데이터를 불러오는 칸의 정보가 달라진다
          /*
          옹벽분류: [
                {
                  단: 1,
                  형식별: this.getCellData(parseExcel, "C45"),
                  재료별: this.getCellData(parseExcel, "X45"),
                  평면선형: this.getCellData(parseExcel, "AG45"),
                  횡단선형: this.getCellData(parseExcel, "BC45"),
                  종단선형: this.getCellData(parseExcel, "AQ45"),
                },
              ],
              옹벽제원: [
                {
                  단: 1,
                  옹벽전면부: { 연장: this.getCellData(parseExcel, "C51"), 높이: this.getCellData(parseExcel, "I51"), 두께상단: this.getCellData(parseExcel, "L51"), 두께하단: this.getCellData(parseExcel, "Q51") },
                  옹벽저판부앞굽판: { 가로: this.getCellData(parseExcel, "U51"), 세로: this.getCellData(parseExcel, "Y51"), 두께앞: this.getCellData(parseExcel, "AB51"), 두께뒤: this.getCellData(parseExcel, "AG51") },
                  옹벽저판부뒷굽판: { 가로: this.getCellData(parseExcel, "AL51"), 세로: this.getCellData(parseExcel, "AP51"), 두께앞: this.getCellData(parseExcel, "AT51"), 두께뒤: this.getCellData(parseExcel, "AY51") },
                  매립깊이: this.getCellData(parseExcel, "BD51"),
                  사면구배: this.getCellData(parseExcel, "BG51"),
                  인접보호시설물현황: { 시설물명: this.getCellData(parseExcel, "C54"), 규모: this.getCellData(parseExcel, "S54") },
                  이격거리: { 내이격거리: this.getCellData(parseExcel, "AG54"), 외이격거리: this.getCellData(parseExcel, "AU54") },
                  배수공: { 지름크기: this.getCellData(parseExcel, "C57"), 개수: this.getCellData(parseExcel, "N57") },
                  앵커유무: { 유무: this.getCellData(parseExcel, "X57"), 개수: this.getCellData(parseExcel, "X57") === "유" ? this.getCellData(parseExcel, "AG57") : "" },
                  시공이음부유무: { 유무: this.getCellData(parseExcel, "AQ57"), 개수: this.getCellData(parseExcel, "AQ57") === "유" ? this.getCellData(parseExcel, "BC57") : "" },
                },
              ],
           */
          const 옹벽단수 = Number(this.getCellData(parseExcel, "R41")) ? Number(this.getCellData(parseExcel, "R41")) : 1;
          const 옹벽분류 = [];
          const 옹벽제원 = [];

          for (let i = 0; i < 옹벽단수; i++) {
            옹벽분류.push({
              단: i + 1,
              형식별: this.getCellData(parseExcel, `C${45 + i}`),
              재료별: this.getCellData(parseExcel, `X${45 + i}`),
              평면선형: this.getCellData(parseExcel, `AG${45 + i}`),
              횡단선형: this.getCellData(parseExcel, `BC${45 + i}`),
              종단선형: this.getCellData(parseExcel, `AQ${45 + i}`),
            });

            const secondRowNo = 51 + 옹벽단수 - 1 + i;
            const thirdRowNo = 54 + ((옹벽단수 - 1) * 2) + i;
            const fourthRowNo = 57 + ((옹벽단수 - 1) * 3) + i;
            옹벽제원.push({
              단: i + 1,
              옹벽전면부: { 연장: this.getCellData(parseExcel, `C${secondRowNo}`), 높이: this.getCellData(parseExcel, `I${secondRowNo}`), 두께상단: this.getCellData(parseExcel, `L${secondRowNo}`), 두께하단: this.getCellData(parseExcel, `Q${secondRowNo}`) },
              옹벽저판부앞굽판: { 가로: this.getCellData(parseExcel, `U${secondRowNo}`), 세로: this.getCellData(parseExcel, `Y${secondRowNo}`), 두께앞: this.getCellData(parseExcel, `AB${secondRowNo}`), 두께뒤: this.getCellData(parseExcel, `AG${secondRowNo}`) },
              옹벽저판부뒷굽판: { 가로: this.getCellData(parseExcel, `AL${secondRowNo}`), 세로: this.getCellData(parseExcel, `AP${secondRowNo}`), 두께앞: this.getCellData(parseExcel, `AT${secondRowNo}`), 두께뒤: this.getCellData(parseExcel, `AY${secondRowNo}`) },
              매립깊이: this.getCellData(parseExcel, `BD${secondRowNo}`),
              사면구배: this.getCellData(parseExcel, `BG${secondRowNo}`),
              인접보호시설물현황: { 시설물명: this.getCellData(parseExcel, `C${thirdRowNo}`), 규모: this.getCellData(parseExcel, `S${thirdRowNo}`) },
              이격거리: { 내이격거리: this.getCellData(parseExcel, `AG${thirdRowNo}`), 외이격거리: this.getCellData(parseExcel, `AU${thirdRowNo}`) },
              배수공: { 지름크기: this.getCellData(parseExcel, `C${fourthRowNo}`), 개수: this.getCellData(parseExcel, `N${fourthRowNo}`) },
              앵커유무: { 유무: this.getCellData(parseExcel, `X${fourthRowNo}`), 개수: this.getCellData(parseExcel, `X${fourthRowNo}`) === "유" ? this.getCellData(parseExcel, `AG${fourthRowNo}`) : "" },
              시공이음부유무: { 유무: this.getCellData(parseExcel, `AQ${fourthRowNo}`), 개수: this.getCellData(parseExcel, `AQ${fourthRowNo}`) === "유" ? this.getCellData(parseExcel, `BC${fourthRowNo}`) : "" },
            })
          }


          this.excelData.push({
            open: false,
            err: [],
            row: {
              관리부서및업체지정: "",
              시설물번호: this.getCellData(parseExcel, "AA4"),
              관리번호: this.getCellData(parseExcel, "AA5"),
              시설물명: this.getCellData(parseExcel, "AA6"),
              관리주체: this.getCellData(parseExcel, "Y13"),
              소유자: this.getCellData(parseExcel, "Y14"),
              전화번호,
              보관자: this.getCellData(parseExcel, "Y15"),
            },
            form: {
              phoneNumber: 전화번호,
              custodian: this.getCellData(parseExcel, "W15"), // 보관자

              facilityNumber: this.getCellData(parseExcel, "Y4"), // 시설물번호
              managementNumber: this.getCellData(parseExcel, "Y5"), // 관리번호
              facilityName: this.getCellData(parseExcel, "Y6"), // 시설물명
              routeDivision: this.getCellData(parseExcel, "AA20"), // 노선구분
              routeDetail: this.getCellData(parseExcel, "AF20"), // 노선상세

              facility_category_id: facilityCategory.id,
              // 시설물 구분
              cat1: facilityCategory.cat1,
              // 시설물 종류
              cat2: facilityCategory.cat2,
              cat3: facilityCategory.cat3,
              // 시설물 종별
              classification: facilityCategory.classification,

              // SOC 성능평가대상
              socEvaluationTarget: this.getCellData(parseExcel, "BF20"),
              address: addresses.join(" "),
              // 관리주체
              management_entity: this.getCellData(parseExcel, "W13") ? this.getCellData(parseExcel, "W13") : this.getCellData(parseExcel, "T22"),
              // 관리주체구분
              management_type: 관리주체구분,
              // 소유자
              owner: this.getCellData(parseExcel, "W14"),
              // 소유자구분
              ownerType: 소유자구분,
              // 사업계획 승인일
              businessPlanApprovalDate: this.setMoment(this.getCellData(parseExcel, "B27")),
              // 준공일
              completionDate: this.setMoment(this.getCellData(parseExcel, "G27")),
              // 하자담보책임만료일
              defectLiabilityExpirationDate1: this.setMoment(this.getCellData(parseExcel, "O27")),
              // 상세제원
              detailedSpecifications: this.getCellData(parseExcel, "V27"),
              // 안전점검 및 정밀안전진단
              safetyInspectionAndDiagnosisHistory: this.getCellData(parseExcel, "Z27"),
              // 보수 보강 이력
              repairAndReinforcementHistory: this.getCellData(parseExcel, "AH27"),
              // 환기구덮개 (접근 가능한 환기구)
              accessibleVentCover: this.getCellData(parseExcel, "AO27"),
              // 설계기간
              designPeriod: this.getCellData(parseExcel, "B29") ? this.convertPeriodDate(this.getCellData(parseExcel, "B29")) : "",
              // 설계자
              designer: this.getCellData(parseExcel, "R29"),
              defectLiabilityExpirationDate2: "",
              // 공사기간
              constructionPeriod: this.getCellData(parseExcel, "AB29") ? this.convertPeriodDate(this.getCellData(parseExcel, "AB29")) : "",
              // 시공자
              contractor: this.getCellData(parseExcel, "AN29"),
              // 총공사비 (백만원)
              totalConstructionCost: this.getCellData(parseExcel, "BA29"),
              // 내진설계 대상 유무
              seismicDesignTarget: this.getCellData(parseExcel, "F31") ? this.getCellData(parseExcel, "F31") : "불명",
              // 내진설계 적용 유무
              seismicDesignApplication: this.getCellData(parseExcel, "R31") ? this.getCellData(parseExcel, "R31") : "불명",
              // 적용내진설계기준
              seismicDesignStandard: this.getCellData(parseExcel, "AB31"),
              // 내진성능평가 실시 유무
              seismicPerformanceEvaluation: this.getCellData(parseExcel, "AN31") ? this.getCellData(parseExcel, "AN31") : "불명",
              // 내진보강 유무
              seismicReinforcement: this.getCellData(parseExcel, "BA31") ? this.getCellData(parseExcel, "BA31") : "불명",
              // 영21조 대상
              young21Target: this.getCellData(parseExcel, "B33"),
              // 감리기간
              auditPeriod: this.convertPeriodDate(this.getCellData(parseExcel, "F33")),
              // 감리자(책임감리원)
              auditor: this.getCellData(parseExcel, "R33"),
              // 사업주체(발주자)
              projectOwner: this.getCellData(parseExcel, "AB33"),
              // 공사명
              constructionName: this.getCellData(parseExcel, "AN33"),
              defectLiabilityExpirationDate: "",
              // 공사감독 공사관리관
              constructionSupervisor: this.getCellData(parseExcel, "BA33"),
              // 작성일
              creationDate: this.setMoment(this.getCellData(parseExcel, "B36")),
              // 작성자, "(인)" 문자열을 제거하고 trim한다
              author: this.getCellData(parseExcel, "M36").replace("(인)", "").trim(),
              // 서명
              signature: "",
              // 최종 수정일
              lastModifiedDate: this.setMoment(this.getCellData(parseExcel, "AC36")),
              // 최종 수정자
              lastModifiedBy: this.getCellData(parseExcel, "AS36"),
              // 비고
              remarks: this.getCellData(parseExcel, "E37"),

              옹벽단수: this.getCellData(parseExcel, "R41"),
              위치좌표시점: this.getCellData(parseExcel, "AJ41"),
              위치좌표종점: this.getCellData(parseExcel, "AW41"),

              옹벽분류,
              옹벽제원,

              otherSpecifications: this.getCellData(parseExcel, "Q58"),

              companyList: [],
              photoList: [],
            },
            categoryInfo: {
              id: facilityCategory.id ? facilityCategory.id : 0,
              cat1: facilityCategory.cat1 ? facilityCategory.cat1 : "",
              cat2: facilityCategory.cat2 ? facilityCategory.cat2 : "",
              cat3: facilityCategory.cat3 ? facilityCategory.cat3 : "",
              classification: facilityCategory.classification ? facilityCategory.classification : "",
            },
          });
        };
        reader.readAsArrayBuffer(file);
      }
    },
    getCellData(sheet, key) {
      if (sheet[key]) return sheet[key];
      else return "";
    },

    inputDetail(data) {
      this.editExcelData.form = data;
    },
    onClickEditExcelData(index) {
      this.editExcelIndex = index;
      this.editExcelData = JSON.parse(JSON.stringify(this.excelData[index]));
    },
    onClickRemoveExcelData(index) {
      this.excelData.splice(index, 1);
    },
    onClickFinishExcelData(index) {
      // this.$set(this.excelData, index, this.editExcelData);
      this.editExcelIndex = null;
      this.editExcelData = null;
    },
    onClickCancelExcelData(index) {
      this.editExcelIndex = null;
      this.editExcelData = null;
    },

    /**
     * 1978-01-01 ~ 1981-12-31 형태의 문자열을 받아서 sDate, eDate로 나눠서 리턴한다
     *
     * @param dateStr
     * @returns {{sDate: string, eDate: string}}
     */
    convertPeriodDate(dateStr) {
      const result = { sDate: "", eDate: "" };
      if (dateStr) {
        // designPeriodStr 값을 '~' 기호로 분리한다
        const periodArr = dateStr.split("~");
        // 만약 2개가 나온다면, 각각 트림하여 designPeriod에 sDate, eDate로 넣어준다
        if (periodArr.length === 2) {
          result.sDate = periodArr[0].trim();
          result.eDate = periodArr[1].trim();
        }
      }
      return result;
    },
    onClickSave() {
      // 엑셀 데이터가 없을때 에러
      if (this.excelData.length < 1) {
        this.$emit("customAlert", "옹벽 및 절토사면 엑셀(FMS) 정보가 없습니다");
        return;
      }

      const posts = this.excelData.map((ed) => {
        const option = {
          project_id: this.projectId, // 프로젝트 ID
          field_name: ed.form.facilityName, // 현장(시설물, 사업장) 이름
          contract_code: ed.form.facilityNumber, // 계약번호
          address: ed.form.address, // 주소
          phone: ed.form.phoneNumber, // 대표번호
          be_completed_at: ed.form.completionDate, // 준공일
          deposit_amount: ed.form.totalConstructionCost, // 총공사비
        };

        // Category
        // if (typeof ed.form.cat4 === "number") {
        //   option.facility_category_id = ed.form.cat4;
        // }
        if (ed.form.facility_category_id > 0) {
          option.facility_category_id = ed.form.facility_category_id;
        }

        // Company
        if (ed.row.관리부서및업체지정.length > 0) {
          option.company_ids = ed.row.관리부서및업체지정.map((com) => com.id);
        }

        // Meta
        option.meta = { ...ed.form };

        return option;
      });

      this.$emit("save", posts);
    },
    // 정렬 후 기타, 기타 외를 배열의 마지막으로 이동하는 함수
    setCatOther(list) {
      list.sort();

      const etcIndex = list.indexOf("기타");
      if (etcIndex > -1) {
        list.splice(etcIndex, 1);
        list.push("기타");
      }
      const etcOutIndex = list.indexOf("기타 외");
      if (etcOutIndex > -1) {
        list.splice(etcOutIndex, 1);
        list.push("기타 외");
      }

      return list;
    },
    setMoment(date) {
      if (!date) return "";
      else if (moment(date).format("YYYY-MM-DD") === "Invalid date") return "";
      else return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped lang="scss">
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  thead {
    th {
      text-align: center;
    }
  }

  th,
  td {
    padding: 0;
  }

  th {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;

    background: #fafafa;
    border-top: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;

    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  .sub-table {
    th {
      background: #7e72f20d;
      border-top: 0;
      padding: 16px 10px;
    }
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }

  .check {
    justify-content: center !important;
    ::v-deep {
      span {
        margin: 0;
      }
    }
  }
}

.errMsg {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #ea5455;
  margin-top: 2px;
}
</style>
